import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { ShoppingCart } from '../../dto/response/shopping-cart.response';
import { tap, catchError, throwError } from 'rxjs';
import {
  AddCartItem,
  ClearCart,
  GetShoppingCart,
  UpdateCart,
} from '../actions/shoppingCart.action';
import { ShoppingCartService } from '../../service/shopping-cart.service';
import { NotificationService } from '../../service/notification.service';

@State<ShoppingCart>({
  name: 'shoppingCart',
  defaults: {
    cart_id: '',
    site_id: '',
    items: [],
    total_price: {
      sale_price: 0,
      origin_price: 0,
      currency: 'EUR',
      currency_id: 'EUR',
    },
  },
})
@Injectable()
export class ShoppingCartState {
  constructor(
    private shoppingCartService: ShoppingCartService,
    private notificationService: NotificationService
  ) { }

  @Selector()
  static shoppingCart(state: ShoppingCart): ShoppingCart {
    return state;
  }

  @Action(GetShoppingCart)
  getShoppingCart(ctx: StateContext<ShoppingCart>) {
    let cartId = ctx.getState().cart_id;
    if (cartId && cartId != '') {
      return this.shoppingCartService.getMyCart(cartId).pipe(
        tap({
          next: (result: ShoppingCart) => {
            ctx.setState({
              ...result,
              // que pongo aqui
            });
          },
          error: (err) => {
            throw new Error(err?.error?.message);
          },
        }),
      );
    }
  }

  @Action(AddCartItem)
  addToCart(ctx: StateContext<ShoppingCart>, action: AddCartItem) {
    let cartId = ctx.getState().cart_id;
    if (cartId && cartId != '') {
      action.cartItem.cart_id = cartId;
    }
    return this.shoppingCartService.addToCart(action.cartItem).pipe(
      tap((result: ShoppingCart) => {
        ctx.setState({
          ...result,
        });
      }),
      catchError((err) => {
        // Handle the error directly here since NGXS doesn't propagate to component subscribe
        this.notificationService.handleBackendError(err);
        return throwError(() => err);
      })
    );
  }



  @Action(UpdateCart)
  updateCart(ctx: StateContext<ShoppingCart>, payload: UpdateCart) {
    console.log(payload.payload);
    return this.shoppingCartService.updateCart(payload.payload).pipe(
      tap({
        next: (result: ShoppingCart) => {
          ctx.setState({
            ...result,
          });
        },
        error: (err) => {
          console.log(err);
          throw new Error(err?.error?.message);
        },
      }),
    );
  }

  @Action(ClearCart)
  clearCart(ctx: StateContext<ShoppingCart>) {
    return ctx.patchState({
      cart_id: '',
      site_id: '',
      items: [],
      total_price: {
        sale_price: 0,
        origin_price: 0,
        currency: 'EUR',
        currency_id: 'EUR',
      },
    });
  }
}
